import useContextUrl from "@common/hooks/useContextUrl";
import useBookingAccess from "@common/hooks/useBookingAccess";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useContextualizadorStore } from "@context/useContextualizadorStore";
import { Scenario } from "@models/ISchema";

const useBookingContextUrl = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { isAdminBooking } = useBookingAccess();
  const scenarios = useContextualizadorStore(state => state?.scenarios);
  const { id, origin, scenario, workspace } = useContextUrl();
  const contextUrl = `${workspace}/${scenario}${origin ? `/${origin}` : ""}`;

  const { scenarioId, originId } = useMemo(() => {
    if (isAdminBooking) {
      return {
        scenarioId: scenario,
        originId: origin,
      };
    }

    const scenarioId = queryParams.get("scenario");
    const originId = queryParams.get("origin");

    return {
      scenarioId: scenarioId,
      originId: originId,
    };
  }, [queryParams, scenario, origin, isAdminBooking]);

  const scenarioDetails = useMemo(() => {
    return (scenarios?.find(s => s.id === scenarioId) || {}) as Scenario;
  }, [scenarios, scenarioId]);

  return {
    id,
    workspace,
    scenario: scenarioId,
    origin: originId,
    contextUrl,
    isAdminBooking,
    scenarioDetails,
    queryParams,
  };
};

export default useBookingContextUrl;
